import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { Card } from 'seagull';
import styles from './GraphWidgetTopCard.module.scss';
/** Renders a card for the 1st row of a graph widget. */ export default function GraphWidgetTopCard(props) {
    const { className, linkTo, testId } = props, rest = _object_without_properties(props, [
        "className",
        "linkTo",
        "testId"
    ]);
    return /*#__PURE__*/ _jsx(Card, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, rest), {
        bi: {
            name: 'graph_widget_top_card'
        },
        testId: testId,
        className: cn(styles.root, className)
    }), linkTo ? {
        as: Link,
        to: linkTo
    } : {}), {
        highlightOnHover: !!linkTo
    }));
}
